import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  PlusCircle,
  RefreshCw,
  RotateCcw,
  ChevronUp,
} from "feather-icons-react/build/IconComponents";
import Swal from "sweetalert2";
import {
  brandGetall,
  brandGettallByGuid,
  deleteBrand,
  getBrandguid,
  getBrandList,
} from "../../services/MasterApiServices";
import BrandModal from "../../components/master/modal/BrandModal";
import withReactContent from "sweetalert2-react-content";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { setheadertoggle } from "../../redux/toggle";
import {
  exportExcel,
  exportPDF,
  HandlePrint,
  renderTooltip,
} from "../../redux/helper";
import { exportMasterExcel, exportMasterPDF, printMasterReport } from "../../core/utils/MasterReportUtils";
import { MasterName } from "../../components/master/ui/masterUi";
import MasterScreen from "../../components/master/ui/MasterScreen";

const Brand = () => {
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");
  const [brandData, setbrandData] = useState([]);
  const [updateData, setUpdateData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const { togglehead } = useSelector((state) => state.headerToggle);
  const {menuItems} = useSelector((state) => state.amc);
  const [permit, setpermit] = useState();
  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };

  useEffect(() => {
    handleBrandList();
    setpermit(menuItems?.menuPermissions?.find(e=> e.menu.name =="Brand"))
  }, []);
  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };
  const modifiedList = Array.isArray(brandData)
    ? brandData?.filter((value) =>
        value.name?.toLowerCase().includes(searchText?.toLowerCase())
      )
    : [];
  const handleBrandList = async () => {
    try {
      const response = await brandGetall();

      if (Array.isArray(response)) {
        setbrandData(response);
      } else {
        setbrandData([]); // If response is not an array, reset to an empty array
      }
    } catch (error) {
      console.log(error?.response?.data?.Message || "something went wrong");
      setbrandData([]);
    }
  };
  const handleEditClick = async (guid) => {
    try {
      const response= brandData?.find(e=>e.guid == guid)
      // const response = await brandGettallByGuid(guid);
      console.log(response,"ressss");
      
      setUpdateData(response); // Set the data for editing
      setModalMode("edit"); // Set the modal mode to 'edit'
      setModalOpen(true); // Open the modal
    } catch (error) {
      console.error(
        "Error fetching brand by GUID:",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };
  const handleDeleteClick = (id) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      cancelButtonColor: "#ff0000",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      console.log(result);
      if (result.isConfirmed) {
        try {
          
          const response = await deleteBrand(id);
          if (response?.data === true) {
            MySwal.fire({
              title: "Deleted!",
              text: "The brand has been deleted.",
              icon: "success",
              confirmButtonColor: "#00ff00",
              confirmButtonText: "OK",
            }).then(() => {
              handleBrandList(); // Refresh the list
              // setSearchText(""); // Clear the search text
            });
          } else {
            MySwal.fire({
              title: "Error!",
              text: "Something went wrong.",
              icon: "error",
              confirmButtonColor: "#ff0000",
              confirmButtonText: "OK",
            });
          }
        } catch (error) {
          console.error(
            "Error deleting Reasontype:",
            error?.response?.data?.Message || "something went wrong"
          );
          MySwal.fire({
            title: "Error!",
            text: error?.response?.data?.Message || "something went wrong",
            icon: "error",
            confirmButtonColor: "#ff0000",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text) => <MasterName text={text} />,
      sorter: (a, b) => a.Name?.length - b.Name?.length,
    },

    ...(permit?.edit || permit?.deletion
      ? [
          {
            title: "Actions",
            dataIndex: "actions",
            key: "actions",
            render: (_, obj) => (
              <div className="action-table-data">
                <div className="edit-delete-action">
                  {permit?.edit && (
                    <Link
                      className="me-2 p-2"
                      to="#"
                      onClick={() => handleEditClick(obj.guid)}
                    >
                      <i data-feather="edit" className="feather-edit"></i>
                    </Link>
                  )}
                  {permit?.deletion && (
                    <Link
                      className="confirm-text p-2"
                      to="#"
                      onClick={() => handleDeleteClick(obj.id)}
                    >
                      <i data-feather="trash-2" className="feather-trash-2"></i>
                    </Link>
                  )}
                </div>
              </div>
            ),
          },
        ]
      : [])
  ];

  const MySwal = withReactContent(Swal);
  const getActiveTabData = () => {
    let fieldMapping = {};
  
    // Function to create the field mapping between column titles and dataIndex values
    const createfieldMapping = (columns) => {
      const mappings = {};
      columns.forEach((col) => {
        mappings[col.title] = col.dataIndex; // Map title to dataIndex
      });
      return mappings;
    };
  
    // Generate the field mapping for the current columns
    fieldMapping = createfieldMapping(columns);
    
    // Return the filtered data, columns, and field mapping
    return { data: modifiedList, columns: columns, fieldMapping, Rname: "Brand"};
  };
  console.log(updateData,"daaaata");
  
  return (
    <MasterScreen
      title="Brand"
      subtitle="Manage Brand here"
      count={modifiedList?.length}
      tools={
        <ul className="table-top-head">
                    <li>
                      <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                        <Link onClick={() => exportMasterPDF(getActiveTabData,"Brand")}>
                          <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                        </Link>
                      </OverlayTrigger>
                    </li>
                    <li>
                      <OverlayTrigger placement="top" overlay={renderTooltip("Excel")}>
                        <Link
                          onClick={() => exportMasterExcel(getActiveTabData,"Brand")}
                        >
                          <ImageWithBasePath
                            src="assets/img/icons/excel.svg"
                            alt="img"
                          />
                        </Link>
                      </OverlayTrigger>
                    </li>
                    <li>
                      <OverlayTrigger placement="top" overlay={renderTooltip("Print")}>
                        <Link
                         onClick={() => printMasterReport(getActiveTabData,"Brand")}
                        >
                          <i data-feather="printer" className="feather-printer" />
                        </Link>
                      </OverlayTrigger>
                    </li>
                      <li>
                        <OverlayTrigger
                          placement="top"
                          overlay={renderTooltip("Refresh")}
                        >
                          <Link
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            onClick={() => handleBrandList()}
                          >
                            <RotateCcw />
                          </Link>
                        </OverlayTrigger>
                      </li>
                      <li>
                        <OverlayTrigger
                          placement="top"
                          overlay={renderTooltip("Collapse")}
                        >
                          <Link
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            id="collapse-header"
                            className={togglehead ? "active" : ""}
                            onClick={handletogglehead}
                          >
                            <ChevronUp />
                          </Link>
                        </OverlayTrigger>
                      </li>
                    </ul>
      }
      onNew={permit?.add ? () => {
                  setModalMode("add"); // Set the modal mode to 'add'
                  setModalOpen(true); // Open the modal
                } : undefined}
      searchValue={searchText}
      onSearchChange={handleSearch}
      onSearchClear={() => setSearchText("")}
      searchPlaceholder="Search brand - any part"
      columns={columns}
      dataSource={modifiedList}
      onRowClick={permit?.edit ? (r) => handleEditClick(r.guid) : undefined}
      selectedKey={modalOpen && modalMode === "edit" ? (updateData?.id ?? updateData?.guid) : null}
      detail={
        modalOpen ? (
          <BrandModal
                  mode={modalMode}
                  data={modalMode === "edit" ? updateData : {}}
                  handleClose={() => setModalOpen(false)}
                  handleRefresh={() => {
                    handleBrandList(); // Refresh the list
                    // Clear the search text
                  }}
                />
        ) : null
      }
    />
  );
};

export default Brand;
